import { Icon, Spacer, SvgLock, SvgUser, SvgUsers, Text } from '@loomhq/lens';
import classnames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateFolderToMoveTo } from 'actions/moveModal';
import {
  SPECIAL_FOLDER_ID_SHARED_VIDEOS,
  SPECIAL_FOLDER_ID_TEAM_VIDEOS,
} from 'constants/folders';

import styles from './styles.module.less';

class TopLevelGridCell extends Component {
  render() {
    const { topLevelFolder, folderToMoveTo } = this.props;

    if (!topLevelFolder) {
      return null;
    }

    let iconColor;
    let icon;

    const isSelectable = this.gridIsSelectable();
    const isSelected =
      topLevelFolder.id != null
        ? folderToMoveTo.id === topLevelFolder.id
        : false;
    const gridCellClass = classnames(
      styles.gridCell,
      { [styles.selectable]: isSelectable },
      { [styles.selected]: isSelected }
    );

    if (isSelected) {
      iconColor = 'white';
    }

    if (!isSelectable) {
      iconColor = 'grey4';
    }

    switch (topLevelFolder.special_id) {
      case SPECIAL_FOLDER_ID_TEAM_VIDEOS:
        icon = <SvgUsers />;
        break;
      case SPECIAL_FOLDER_ID_SHARED_VIDEOS:
        icon = <SvgLock />;
        break;
      default:
        icon = <SvgUser />;
    }

    return (
      <div className={styles.topLevelWrapper}>
        <div className={styles.cellWrapper}>
          <div className={gridCellClass} onClick={this.select}>
            <Spacer right={2}>
              <Icon icon={icon} color={iconColor} />
            </Spacer>
            <Text color={!isSelectable ? 'bodyDimmed' : ''}>
              {topLevelFolder.name}
            </Text>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { folders, topLevelFolder, updateFolderToMoveTo } = this.props;

    if (folders.length === 0 && this.gridIsSelectable()) {
      updateFolderToMoveTo(topLevelFolder);
    }
  }

  select = e => {
    e.preventDefault();

    if (!this.gridIsSelectable()) {
      return;
    }

    const { folderToMoveTo, topLevelFolder, updateFolderToMoveTo } = this.props;

    if (folderToMoveTo.id === topLevelFolder.id) {
      return;
    }

    updateFolderToMoveTo(topLevelFolder);
  };

  gridIsSelectable = () => {
    const { topLevelFolder, currentFolderId } = this.props;
    let isSelectable = true;

    if (topLevelFolder.special_id === SPECIAL_FOLDER_ID_SHARED_VIDEOS) {
      isSelectable = false;
    }

    if (topLevelFolder.id === currentFolderId) {
      isSelectable = false;
    }

    return isSelectable;
  };
}

const mapState = state => {
  const { checked_items: checkedItems, folder_id: currentFolderId } =
    state.videos_dashboard;

  const { folders, folderToMoveTo, topLevelFolder } = state.moveModal;

  return {
    topLevelFolder,
    folderToMoveTo,
    checkedItems,
    currentFolderId,
    folders,
  };
};

const mapDispatch = dispatch => {
  return {
    updateFolderToMoveTo: folder => dispatch(updateFolderToMoveTo(folder)),
  };
};

export default connect(mapState, mapDispatch)(TopLevelGridCell);
